import React from "react";
import aboutImg from "../../images/aboutus.jpg";
import "./About.css";
import ImageFootballTraining from "../../images/football_training.jpg";
import Service from "../Service";

const About = () => {
  return (
    <section className="container p-3 about">
      <Service title="" imgUrl={aboutImg} />
      {/*<figure className="about__img">*/}
      {/*  <img*/}
      {/*    loading="lazy"*/}
      {/*    src={aboutImg}*/}
      {/*    alt="TssClub About Ilustration"*/}
      {/*    aria-label="TssClub Image Example"*/}
      {/*  />*/}
      {/*</figure>*/}
      <header className="about__header">
        <h2>
          About <span>Us</span>
        </h2>
        <p className="txt-justify">
          Welcome to the Official TSS football club website. Our aim is to create
          a world class football club by finding young talent in India.
        </p>
      </header>
    </section>
  );
};

export default About;
